import { render, staticRenderFns } from "./PDFDocument.vue?vue&type=template&id=47bec96f"
import script from "./PDFDocument.vue?vue&type=script&lang=js"
export * from "./PDFDocument.vue?vue&type=script&lang=js"
import style0 from "./PDFDocument.vue?vue&type=style&index=0&id=47bec96f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports